import React from 'react'
import Card from '../../core/Card'
import { BackIcon } from '../../core/icons'
import { Link } from 'react-router-dom'
import Place from './Place'
import { Form } from 'antd';
import { connect } from 'react-redux'
import { message } from 'antd';
import { reduxForm, submit } from 'redux-form'


// TODO rename to Update.js (along with List.js, New.js)

import { updateFavoritePlace, deleteFavoritePlace } from './actions'

const mapStateToProps = (state, ownProps) => {
  const placeId = ownProps.placeId || ownProps.match.params.placeId
  const favePlace = state.models.places.byId[placeId]
  console.log({placeId, favePlace})
  const getAddress = ({street, city, state, country}) => (street||'')+" "+city+" "+state+" "+country
  return {
    initialValues: favePlace,
    hasName: favePlace && favePlace.name && favePlace.name.length>0,
    address: favePlace && getAddress(favePlace),
    title: `Favorite Place`,
    buttonTitle: 'Save',

    // overrides from TripList > NameThisPlace modal
    hideTitleBar: ownProps.initialValues && ownProps.initialValues.addedOnTripList

  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemoteSubmit: () => dispatch(submit('favoritePlace')),
    onDelete: () => dispatch(deleteFavoritePlace(ownProps.match.params.placeId))
      .then(()=>message.success('Removed place successfully.', 10)),
  }
}
const Update = reduxForm({
  form: 'favoritePlace',
  onSubmit: (values, dispatch, ownProps)=>
    dispatch(updateFavoritePlace({...values, token_id: ownProps.placeId || ownProps.match.params.placeId}))
})(Place)


export default connect(mapStateToProps, mapDispatchToProps)(Update)



// WEBPACK FOOTER //
// ./src/account/favorite-places/Update.js